import { render, staticRenderFns } from "./AccountCardReplaceBtn.vue?vue&type=template&id=47052de8&"
import script from "./AccountCardReplaceBtn.vue?vue&type=script&lang=js&"
export * from "./AccountCardReplaceBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports